import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LmdkNzF2aDAgewogIHBvc2l0aW9uOiByZWxhdGl2ZTsKICB3aWR0aDogMjdweDsKICBoZWlnaHQ6IDE3cHg7CiAgb2JqZWN0LWZpdDogY29udGFpbjsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LmdkNzF2aDEgewogIHdpZHRoOiAxMDAlOwogIGhlaWdodDogMTAwJTsKfQ';
export var flag = 'gd71vh0';
export var flagImage = 'gd71vh1';